import getErrorKey from '../getErrorKey';

const errorPrefix = 'checkout.not.present.in.autocomplete.list';

const validateAutocompleteField = (setValues, fieldName) => (value) => {
  if (!value || !setValues.length > 0) return;
  
  const errorKey = getErrorKey(fieldName, errorPrefix);
  
  return setValues.includes(value) ? undefined : errorKey;
};

export default validateAutocompleteField;
